export const LOGOUT ="LOGOUT";
export const SIGN_IN_SUCCESS="SIGN_IN_SUCCESS";
export const SIGN_IN_ERROR="SIGN_IN_ERROR";
export const SELECTED_BUREAU = "SELECTED_BUREAU";